import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvConfigService } from 'ngx-mat-esign360/lib/core/services/env-config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ITransactionEvent } from '../model/transaction-event.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private envConfig: EnvConfigService) {}

  getDto(transactionId: string): Observable<any> {
    return this.http.get<any>(`${this.envConfig.data.signServerUrl}/Transaction/${transactionId}`);
  }

  getDocumentPdf(documentPdfId: string): Observable<Blob> {
    return this.http
      .get<BlobPart>(`${this.envConfig.data.signServerUrl}/Object/${documentPdfId}`, {
        responseType: 'blob' as 'json',
      })
      .pipe(
        map((data) => {
          return new Blob([data], { type: 'application/pdf' });
        })
      );
  }

  sendEvent(event: ITransactionEvent): Observable<void> {
    return this.http.post<void>(`${this.envConfig.data.signServerUrl}/Event`, event);
  }
}
